///jacques-andre-editeur\proshop-v2\frontend\src\components\NewsCard.jsx
import BookCard from '../components/BookCard';
import AuthorCard from '../components/AuthorCard';
import DOMPurify from 'dompurify';

const NewsCard = ({ news }) => {
    console.log('news : ', news)
    
  return (
    <div className='news-card'>
        {news.image && (
          <img src={news.image} className="news-img" title={news.title} alt={news.title} />   
        )}
        <div className='news-event'>{news.event}</div>
        <div className='h2-container'><h2>{news.title}</h2></div>
        <div className='news-link'><a href={news.linkRelated.startsWith('http') ? news.linkRelated : `https://${news.linkRelated}`} target="_blank" rel="noopener noreferrer">{news.linkRelated}</a></div>
        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(news.description) }} />
        {/* {(news.authorsRelated?.length > 0 || news.bookRelated?.length > 0) && (<div className='news-event'>Aller plus loin</div>)} */}
        {news.authorsRelated?.length > 0 && ( 
          <div className="author-row">
            {news.authorsRelated.map((author) => (
              <div key={author._id}>
                <AuthorCard key={author._id} author={author} />
              </div>
            ))}
          </div>     
        )}
        {news.bookRelated?.length > 0 && (
            <div className="book-news-row">
              {news.bookRelated.map((book) => (
                  <div className='book-card' key={book._id}>
                    <BookCard key={book._id} book={book} showPanier={true} />
                  </div>
              ))}
            </div>
        )}
    </div>
  );
};

export default NewsCard;
